import * as React from 'react';
import { ICardProps } from '../types';

import cn from 'clsx';

import * as styles from '../styles.css';
import { IconArrowRight24, IconHotLeads16, Label, UIHeading2, UIText1 } from '@cian/ui-kit';

export const CardMedium: React.FC<ICardProps> = ({ onClick, children, title, description, hasLabel, className }) => {
  return (
    <div
      className={cn(styles['card'], styles['card-medium'], onClick && styles['card-clickable'], className && className)}
      onClick={onClick}
    >
      {onClick && (
        <div className={styles['btn']}>
          <IconArrowRight24 color="primary_100" />
        </div>
      )}

      <div>
        {hasLabel && (
          <div className={styles['label']}>
            {' '}
            <Label
              icon={<IconHotLeads16 color="accent-negative-primary" />}
              color="accent-negative-primary"
              background="accent-negative-secondary"
            >
              Популярное
            </Label>
          </div>
        )}

        <UIHeading2 as="p">{title}</UIHeading2>
        <UIText1>{description}</UIText1>
      </div>

      {children}
    </div>
  );
};
